import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		tabs: {
			marginBottom: theme.spacing(3),
		},
		previewImage: {
			maxWidth: 200,
			maxHeight: 120,
			display: "block",
			marginBottom: theme.spacing(1),
		},
		uploadRow: {
			marginBottom: theme.spacing(2),
		},
		helperText: {
			marginBottom: theme.spacing(2),
		},
	} satisfies Record<string, CSSObject>);
};
